export const siteSettings = {
  name: "Bull Edge Markets",
  link: "https://bulledgemarkets.com",
  email: "support@bulledgemarkets.com",
  appLink: "https://app.bulledgemarkets.com",
};
